import * as React from "react";

import { hasStoredValue }  from '../storage/storage-utils';
import { regFlowCompleteKey } from '../registration/registration-utils';
import SuppressNav from '../layout/SuppressNav';
import AddressSearch from '../address/AddressSearch';

import styles from './PreRegister.module.css';

/**
 * PreRegister splash page: collect address and contiunue to reg flow
 */
const FramableLocationSearch = () => {
  
  const [registrationComplete, setRegistrationComplete] = React.useState();

  React.useEffect(() => {
    if (hasStoredValue(regFlowCompleteKey)) {
      setRegistrationComplete(true);
    }
  }, [setRegistrationComplete]);

  return (
    <div className={styles.framedContentWrap}>
      <SuppressNav /> 
      { registrationComplete  
        ? <div className={styles.successMsg}>
           <div className={styles.hdrLarge}>Congrats, you’ve officially signed&nbsp;up!</div>
           <div className={styles.hdrSmall}>You’ll be first in line when we launch our&nbsp;services</div>
          </div> 
        : <>
            <div className={styles.framedFormHeader}>
              <div className={styles.hdrLarge}>Launching soon in Boston</div>
              <div className={styles.hdrSmall}>Sign up now to earn free cannabis delivery&nbsp;credits*</div>
            </div>
            <div className={styles.inputWrap}>
              <AddressSearch
                isPreRegistration 
                onComplete={() => {}} />
                <div className={styles.promoDetails}>
                  *Credits for free Zip Run delivery (Regularly $3.99) maximum&nbsp;credits&nbsp;per&nbsp;customer:&nbsp;2
                </div>  
            </div>
          </>
      }
    </div>
  );
}

export default FramableLocationSearch;